import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BeginAgainGuide from "./BeginAgainGuide";
import { Toaster } from "sonner";

// Fixed header height (h-20 = 5rem = 80px). Keep in sync with Navbar.
const HEADER_OFFSET = 88;

const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Anchor navigation: scroll to the target section after paint. We retry a
    // few times because the destination page may still be mounting when the
    // hash change happens (e.g. cross-route nav to /classes#online-chapel).
    if (hash) {
      const id = hash.slice(1);
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: "smooth" });
          return;
        }
        if (attempts < 10) {
          attempts += 1;
          setTimeout(tryScroll, 60);
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <BeginAgainGuide />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
};

export default Layout;
